import React from 'react';
import { withStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';

const AxlButton = withStyles(
  React.forwardRef(({ isCancel, ...other }, ref) => <Button ref={ref} {...other} />),
  (theme, props) => ({
    root: {
      textTransform: 'none',
      border: 0,
      borderRadius: 3,
      padding: '8px 30px',
      boxShadow: 'None',
      lineHeight: 'normal',
      backgroundColor: props.isCancel ? '#9da5b6' : 'none',
      color: props.isCancel ? '#000' : 'none',
      '&.Mui-disabled': {
        backgroundColor: '#bec6d8',
        color: '#fff',
      },
    },
    label: {
      textTransform: 'capitalize',
    },
  }),
);

export const CustomButton = withStyles(Button, {
  root: {
    fontWeight: 600,
    fontFamily: 'AvenirNext',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textTransform: 'none',
    minWidth: 'unset',
    padding: '6px 12px',
    marginLeft: '5px',
    boxShadow: 'None',
    borderRadius: 3,
  },
});

export { AxlButton };
